import React, { useState, useEffect } from "react"
import { useForm } from "react-hook-form"
import ModalOtpRecover from "../../molecules/modal-otp-recover/modal-otp-recover"
import RegisterModal from "../../../shared/components/organisms/register-modal/register-modal"
import CardContainer from "../../../shared/components/molecules/card-container/card-container"
import InputMaterial from "../../../shared/components/atoms/input-material/input-material"
import Button from "../../../shared/components/atoms/Button/Button"
import AuthService from "../../../shared/services/authentication"
import BtnWhatsapp from "../../../shared/components/atoms/btn-whatsapp/btn-whatsapp"
import { PASSWORD_MIN_LENGTH } from "../../../shared/state/constants/appConstants"
import { siteUrl } from "../../../shared/state/utils/site-url"
import BackButton from "../../../shared/components/atoms/back-button/back-button"
import useModalGeneric from '../../../shared/hooks/useModalGeneric'
import useBrowserMode from '../../../shared/hooks/useBrowserMode'
import "./recovery-content.scss"
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode"

const RecoveryContent = props => {
	const [isModal, showModal, hideModal] = useModalGeneric(true)
  const [isLoading, setIsLoading] = useState()
  const [isOpenModalSuccess, setIsOpenModalSucess] = useState(false)
  const [credentials, setCredentials] = useState()
  const { register, errors, handleSubmit, watch, setError } = useForm()
  const { isBrowser } = useBrowserMode();
  const { homeLink } = useHomeLinkMode()


  const onSubmit = async ({ password }) => {
    try {
      setIsLoading(true)
      let userPayload= localStorage.getItem("credentials") ? JSON.parse(localStorage.getItem("credentials")) : "";
      localStorage.getItem("credentials") ? localStorage.removeItem("credentials") : ""
      localStorage.getItem("userEmail") ? localStorage.removeItem("userEmail") : ""

      const payload = {
        accessToken: userPayload.token ? userPayload.token : credentials,
        proposedPassword: password,
        previousPassword: userPayload.code ? userPayload.code : credentials,
      }

      const res = await AuthService.sendNewPass(payload, {
        headers: { Authorization: userPayload.idToken ? userPayload.idToken : credentials },
      })
      if (res.status === 200) {
        setIsOpenModalSucess(true)
      } else {
        setError("password", "api-validation", res.userMessage)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if(localStorage.getItem("stepRecoveryPassword") === "2"){
      localStorage.removeItem("stepRecoveryPassword");
      hideModal();
    }
  },[])

  let windowValidation = isBrowser && true;
  let isFromRecoveryPassword = windowValidation ?  !!localStorage.getItem("fromRecoveryPassword") : "";
  windowValidation ? localStorage.removeItem("fromRecoveryPassword") : "";

  useEffect(() => {
    let location = isBrowser && window.location.href;
    if (location.at(-1) === homeLink + "autenticacion/recuperar-contrasena/#" && isFromRecoveryPassword ) {
      showModal()
      isFromRecoveryPassword = false;
    }
  }, [isFromRecoveryPassword])


  return (
    <>
      <CardContainer>
        <div className="f-recovery-password">
          <BackButton href={siteUrl + "/autenticacion"} />
          <h1 className="f-recovery-password__title f-h2">
            Ingresa una nueva contraseña 
          </h1>
          <p className="f-recovery-password__description f-p">
            Actualiza tu contraseña con un mínimo de 6 caracteres. ¡Escríbela y
            guárdala para que no la olvides!
          </p>
          <form className="f-form-recover" onSubmit={handleSubmit(onSubmit)}>
            <InputMaterial
              errors={errors}
              type="password"
              register={register({
                required: {
                  value: true,
                  message: "La contraseña es requerida.",
                },
                minLength: {
                  value: PASSWORD_MIN_LENGTH,
                  message: "La contraseña debe contener mínimo 6 caracteres.",
                },
              })}
              name="password"
              label="Crea una contraseña *"
            />
            <InputMaterial
              type="password"
              register={register({
                required: { value: true, message: "Este campo es requerido" },
                validate: {
                  passwordExact: value =>
                    watch("password") === value ||
                    "Las contraseñas no coinciden ",
                },
              })}
              errors={errors}
              name="confirmPassword"
              label="Verifica tu contraseña"
            />
            <Button
              isEnabled={isLoading}
              text="FINALIZAR"
              classname="f-button f-button--primary"
            />
            <BtnWhatsapp />
          </form>
        </div>
      </CardContainer>
      {isModal && (
        <ModalOtpRecover
          onClose={() => {
            window.location.href = siteUrl + "/autenticacion"
          }}
          onSuccessAuth={credentials => {
            setCredentials(credentials)
            localStorage.setItem("credentials", JSON.stringify(credentials))
            hideModal()
          }}
          hideModal={() => hideModal()}
        />
      )}
      {isOpenModalSuccess && (
        <RegisterModal
          title="¡Felicidades!"
          description={
            <>
              Tu contraseña se actualizó correctamente, ahora puedes disfrutar
              de todos los beneficios que tenemos para ti.
            </>
          }
          onClose={() => {
            window.location.href = siteUrl + "/autenticacion"
          }}
        >
          <div className="f-modal-success-recovery">
            <Button
              text="ACEPTAR"
              type="button"
              classname="f-button f-button--primary"
              onClickAction={() => {
                window.location.href = siteUrl + "/autenticacion"
              }}
            />
          </div>
        </RegisterModal>
      )}
    </>
  )
}

export default RecoveryContent
